import { render, staticRenderFns } from "./DeceasedWillStep.vue?vue&type=template&id=9034a18a"
import script from "./DeceasedWillStep.vue?vue&type=script&lang=ts"
export * from "./DeceasedWillStep.vue?vue&type=script&lang=ts"
import style0 from "./DeceasedWillStep.vue?vue&type=style&index=0&id=9034a18a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports